import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
};

const registersSidebarSlice = createSlice({
  name: "registersSidebar",
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.open = true;
    },
    hide: (state) => {
      state.open = false;
    },
    toggle: (state) => {
      state.open = !state.open;
    },
  },
});

export const { show, hide, toggle } = registersSidebarSlice.actions;
export default registersSidebarSlice.reducer;
